import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { WithdrawalRequest,WithdrawState } from './types';

const initialState: WithdrawState = {
  history: [],
  historyLoading: false,
  submitting: false,
  error: null,
  success: false,
};

const withdrawSlice = createSlice({
  name: 'withdraw',
  initialState,
  reducers: {
    // Saga triggers
    submitRequest(_state, _action: PayloadAction<{ amount: number; wallet: string }>) {},
    fetchHistoryRequest() {},

    setSubmitting(state, action: PayloadAction<boolean>) {
      state.submitting = action.payload;
    },
    setHistoryLoading(state, action: PayloadAction<boolean>) {
      state.historyLoading = action.payload;
    },
    submitSuccess(state, action: PayloadAction<WithdrawalRequest>) {
      state.submitting = false;
      state.success = true;
      state.error = null;
      state.history.unshift(action.payload);
    },
    submitFailure(state, action: PayloadAction<string>) {
      state.submitting = false;
      state.error = action.payload;
      state.success = false;
    },
    setHistory(state, action: PayloadAction<WithdrawalRequest[]>) {
      state.history = action.payload;
      state.historyLoading = false;
    },
    resetStatus(state) {
      state.error = null;
      state.success = false;
    },
    // WebSocket update — refresh a single record in history
    updateHistoryItem(state, action: PayloadAction<WithdrawalRequest>) {
      const idx = state.history.findIndex((r) => r.id === action.payload.id);
      if (idx !== -1) {
        state.history[idx] = action.payload;
      }
    },
  },
});

export const withdrawActions = withdrawSlice.actions;
export const withdrawReducer = withdrawSlice.reducer;
